import { Component, OnInit } from '@angular/core';
import { PhoneNumbersService } from './phone-numbers.service';
import { Ng1IpInfoService } from '../shared/ng1/ng1-ip-info.service';
import { AmplitudeService } from '../shared/services/amplitude.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Subscription } from '../shared/models/plans';
import { AccountSettingsService } from '../my-account/account-settings.service';
import { Ng1ModalService } from '../shared/ng1/ng1-modal.service';

@Component({
  selector: 'cc-phone-numbers',
  templateUrl: './phone-numbers.component.html',
  styleUrls: ['./phone-numbers.component.scss']
})
export class PhoneNumbersComponent implements OnInit {
  public phoneNumbers;
  public subscription$: Observable<Subscription>;
  public isFreePlan: boolean;

  constructor(
    private accountSettingsService: AccountSettingsService,
    private phoneNumbersService: PhoneNumbersService,
    private ng1IpInfoService: Ng1IpInfoService,
    private amplitudeService: AmplitudeService,
    private ng1ModalService: Ng1ModalService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.subscription$ = this.accountSettingsService.getSubscription();
    this.subscription$.subscribe(plans => {
      const plan = plans.licenses[0].planName;
      this.isFreePlan = plan === 'Free' ? true : false;
    });
    console.log(this.isFreePlan);

    this.phoneNumbersService.getPhoneNumbers().subscribe(phoneNumbers => {
      this.phoneNumbers = phoneNumbers;

      // TODO: Check why the line below is not working correctly and always giving null
      // const id = this.route.snapshot.paramMap.get('id');
      const id = window.location.href.includes('settings') || window.location.href.includes('custom');

      if (!id && this.phoneNumbers && this.phoneNumbers.length > 0) {
        const number = id ? this.phoneNumbers.find(n => n.id === id) : this.phoneNumbers[this.phoneNumbers.length - 1];
        const currentNumber = number || this.phoneNumbers[this.phoneNumbers[0]];
        const urlType = currentNumber.inbound ? 'settings' : 'custom';
        this.router.navigateByUrl(`/phone-numbers/${currentNumber.id}/${urlType}`);
      }
    });
  }

  isEmptyPhoneNumbersList() {
    return this.phoneNumbers && this.phoneNumbers.length === 0;
  }

  goToNewNumber() {
    if (this.isFreePlan) {
      this.showUpgradeAccountModal();
      return;
    } else {
      const code = this.ng1IpInfoService.getCountry();
      this.amplitudeService.logEvent('Panel:Numbers: Add new number clicked', { code });
      this.router.navigateByUrl(`/get-new-number/pricing/${code}`);
    }
  }

  showUpgradeAccountModal() {
    return this.ng1ModalService.lazyModalService
      .showModal(
        {
          title: 'TRIAL_MODAL.TITLE',
          body: 'TRIAL_MODAL.PHONE_NUMBER_TEXT',
          confirm: 'TRIAL_MODAL.CONFIRM'
        },
        true
      )
      .then(() => {
        this.router.navigateByUrl('/choose-plan');
      });
  }
}
